import { ErrorMessageType } from '../interfaces/error-message.interface';

const KEY_PREFIX = 'shop-settings.general.errors.';

const REQUIRED_KEY = `${KEY_PREFIX}required`;
const LENGTH_KEY = `${KEY_PREFIX}shopName.length`;
const INVALID_EMAIL_KEY = `${KEY_PREFIX}email.invalid`;
const INVALID_URL_KEY = `${KEY_PREFIX}url.invalid`;
const INVALID_URL_FORMAT = `${KEY_PREFIX}url.invalidFormat`;
const INVALID_URL_CATEGORY_SLUG = `${KEY_PREFIX}url.missingSlug`;
const INVALID_URL_SHOTY_SLUG = `${KEY_PREFIX}url.urlSlugTooShort`;
const INVALID_URL_RESERVED = `${KEY_PREFIX}url.urlReserved`;

export const SETTINGS_GENERAL_PHONE_FORM_FIELD_ERROR_MESSAGE_KEYS_MAP = new Map<string, string>(
  Object.entries({
    required: REQUIRED_KEY,
    regularInvalid: `${KEY_PREFIX}phone`,
    mask: `${KEY_PREFIX}phone`,
  }),
);

export const SETTINGS_GENERAL_FORM_FIELD_ERROR_MESSAGE_KEYS_MAP = new Map<string, ErrorMessageType>(
  [
    [
      'name',
      {
        required: REQUIRED_KEY,
        minlength: LENGTH_KEY,
        maxlength: LENGTH_KEY,
        leadingOrTrailingWhitespace: `${KEY_PREFIX}shopName.whitespace`,
        pattern: `${KEY_PREFIX}shopName.invalidCharacters`,
      },
    ],
    [
      'email',
      {
        required: REQUIRED_KEY,
        email: INVALID_EMAIL_KEY,
        invalidFormat: INVALID_EMAIL_KEY,
      },
    ],
    [
      'url',
      {
        required: `${KEY_PREFIX}url.required`,
        invalid: INVALID_URL_KEY,
        urlSlugCustomFormat: INVALID_URL_KEY,
        urlInvalidFormat: INVALID_URL_FORMAT,
        missingSlug: INVALID_URL_CATEGORY_SLUG,
        urlSlugTooShort: INVALID_URL_SHOTY_SLUG,
        urlReserved: INVALID_URL_RESERVED,
      },
    ],
    [
      'address',
      {
        invalidShippingAddress: `${KEY_PREFIX}address.invalid`,
      },
    ],
    [
      'city',
      {
        invalidCity: `${KEY_PREFIX}city.invalid`,
      },
    ],
    [
      'state',
      {
        invalidState: `${KEY_PREFIX}state.invalid`,
      },
    ],
    [
      'zipCode',
      {
        mask: `${KEY_PREFIX}zipCode.invalid`,
      },
    ],
    [
      'description',
      {
        invalid: `${KEY_PREFIX}description.invalid`,
      },
    ],
  ],
);
